import { EquipmentAlertForm } from "@smartship-services/ui/forms";

const EquipmentAlertPage = () => {
  return <EquipmentAlertForm />;
};

export default EquipmentAlertPage;
